import React, { CSSProperties } from "react";

export const Separator: React.FC = () => {
    const style: CSSProperties = {
        backgroundColor: "rgba(187, 187, 187,.5)",
        height: 1,
        width: "100%",
    };
    return <div style={style}></div>;
};
